import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { registrationAction } from "../../redux/actions";
import { REGISTRATION_FORM_INITIAL } from "../../redux/initialStateConstants";
import { registrationSagaAction } from "../../redux/sagaActions";
import Checkbox from "../Checkbox/Checkbox";

const Registration = () => {
    const dispatch = useDispatch();
    const registration_form = useSelector(state => state.registration_form);

    // Согласие на обработку персональных данных
    const [privacyPolicyAgreement, setPrivacyPolicyAgreement] = useState(false);

    return (
        <div className="form">
            <div className="form__mask"/>
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close" onClick={ () => dispatch(registrationAction(REGISTRATION_FORM_INITIAL)) }/>
                        <div className="form__title">Регистрация</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Имя и фамилия</div>
                        <input
                            type="text" className="input"
                            value={ registration_form.name }
                            onInput={ event => dispatch(registrationAction({
                                ...registration_form,
                                name: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Телефон</div>
                        <input
                            type="text" className="input"
                            value={ registration_form.phone }
                            onInput={ event => dispatch(registrationAction({
                                ...registration_form,
                                phone: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Почта</div>
                        <input
                            type="text" className="input"
                            value={ registration_form.email }
                            onInput={ event => dispatch(registrationAction({
                                ...registration_form,
                                email: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Пароль</div>
                        <input
                            type="password" className="input"
                            value={ registration_form.password }
                            onInput={ event => dispatch(registrationAction({
                                ...registration_form,
                                password: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Дата рождения в формате дд.мм.гггг</div>
                        <input
                            type="text" className="input"
                            value={ registration_form.birthday }
                            onInput={ event => dispatch(registrationAction({
                                ...registration_form,
                                birthday: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Пол</div>
                        <div style={{ display: 'flex', gap: '18px' }}>
                            <div className="checkbox__wrapper"
                                 onClick={ () => dispatch(registrationAction({
                                    ...registration_form,
                                    gender: 'male'
                                })) }
                            >
                                <div className={ `checkbox ${ registration_form.gender === 'male' ? 'checkbox--active' : '' }` }/>
                                <div className="checkbox__caption">Муж</div>
                            </div>
                            <div className="checkbox__wrapper"
                                 onClick={ () => dispatch(registrationAction({
                                     ...registration_form,
                                     gender: 'female'
                                 })) }
                            >
                                <div className={ `checkbox ${ registration_form.gender === 'female' ? 'checkbox--active' : '' }` }/>
                                <div className="checkbox__caption">Жен</div>
                            </div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="privacy">
                            <Checkbox
                                active={ privacyPolicyAgreement }
                                caption={ `` }
                                handler={ () => setPrivacyPolicyAgreement(!privacyPolicyAgreement) }
                            />
                            <div className="privacy__caption">
                                Даю согласие на обработку своих персональных данных, на условиях и для целей, определённых <a className="privacy__link" href="https://alga.by/docs/privacy_policy_site_fitness.pdf" target="_blank">Политикой конфиденциальности</a>
                            </div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div
                            className={ `button ${ !privacyPolicyAgreement ? 'button--inactive' : '' }` }
                            onClick={ () => dispatch(registrationSagaAction({
                                name: registration_form.name,
                                phone: registration_form.phone,
                                email: registration_form.email,
                                birthday: registration_form.birthday,
                                gender: registration_form.gender,
                                password: registration_form.password
                            })) }
                        >Зарегистрироваться</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Registration;